<template>
    <div class="section">
        <div class="columns">
            <div class="column">
                <h1 class="title has-text-centered" v-if="isCreateForm">Create new price plan.</h1>
                <h1 class="title has-text-centered" v-else="">Update new price plan.</h1>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <name-input></name-input>
                <country-select></country-select>
                <user-type-select></user-type-select>
                <deposit-rate-select></deposit-rate-select>
                <deposit-input></deposit-input>
                <max-bids-input></max-bids-input>
                <bid-amount-input></bid-amount-input>
                <max-group-input></max-group-input>
                <payment-terms-input></payment-terms-input>
                <payment-due-input></payment-due-input>
                <roro-fee-input></roro-fee-input>
                <container-fee-input></container-fee-input>
                <free-parking-check-box></free-parking-check-box>
            </div>
            <div class="column">
                <inland-cost-input></inland-cost-input>
                <parking-fee-input></parking-fee-input>
                <lg-fee-input></lg-fee-input>
                <degas-input></degas-input>
                <inspection-japan-input></inspection-japan-input>
                <odometer-fix-input></odometer-fix-input>
                <late-fee></late-fee>
                <negotiation-fee-input></negotiation-fee-input>
                <local-purchase-fee></local-purchase-fee>
                <yahoo-fee-input></yahoo-fee-input>
                <stock-discount-fee></stock-discount-fee>
                <allocated-credit-input></allocated-credit-input>
            </div>
        </div>
        <div class="columns">
            <div class="column has-text-centered">
                <button class="button" @click="goBack">Back</button>
                <submit-new-plan v-if="isCreateForm"></submit-new-plan>
                <update-price-plan v-else=""></update-price-plan>
            </div>
        </div>
    </div>
</template>

<script>
    import CountrySelect from './Inputs/CountrySelect.vue'
    import UserTypeSelect from './Inputs/UserTypeSelect.vue'
    import DepositRateSelect from './Inputs/DepositRateSelect.vue'
    import DepositInput from './Inputs/DepositInput.vue'
    import MaxBidsInput from './Inputs/MaxBidsInput.vue'
    import MaxGroupInput from './Inputs/MaxGroupInput.vue'
    import BidAmountInput from './Inputs/BidAmountInput.vue'
    import PaymentTermsInput from './Inputs/PaymentTermsInput.vue'
    import PaymentDueInput from './Inputs/PaymentDueInput.vue'
    import RoroFeeInput from './Inputs/RoroFeeInput.vue'
    import ContainerFeeInput from './Inputs/ContainerFeeInput.vue'
    import InlandCostInput from './Inputs/InlandCostInput.vue'
    import FreeParkingCheckBox from './Inputs/FreeParkingCheckBox.vue'
    import ParkingFeeInput from './Inputs/ParkingFeeInput.vue'
    import LgFeeInput from './Inputs/LgFeeInput.vue'
    import DegasInput from './Inputs/DegasInput.vue'
    import InspectionJapanInput from './Inputs/InspectionJapanInput.vue'
    import OdometerFixInput from './Inputs/OdometerFixInput.vue'
    import LateFee from './Inputs/LateFee.vue'
    import NegotiationFeeInput from './Inputs/NegotiationFeeInput.vue'
    import LocalPurchaseFee from './Inputs/LocalPurchaseFee.vue'
    import YahooFeeInput from './Inputs/YahooFeeInput.vue'
    import StockDiscountFee from './Inputs/StockDiscountFee.vue'
    import SubmitNewPlan from './Inputs/SubmitNewPlan.vue'
    import NameInput from './Inputs/NameInput.vue'
    import UpdatePricePlan from './Inputs/UpdatePricePlan.vue'
    import AllocatedCreditInput from "./Inputs/AllocatedCreditInput";
    export default {
        components: {
            CountrySelect,
            UserTypeSelect,
            DepositRateSelect,
            DepositInput,
            MaxBidsInput,
            MaxGroupInput,
            PaymentTermsInput,
            PaymentDueInput,
            RoroFeeInput,
            ContainerFeeInput,
            InlandCostInput,
            FreeParkingCheckBox,
            ParkingFeeInput,
            LgFeeInput,
            DegasInput,
            InspectionJapanInput,
            OdometerFixInput,
            LateFee,
            NegotiationFeeInput,
            LocalPurchaseFee,
            YahooFeeInput,
            StockDiscountFee,
            SubmitNewPlan,
            BidAmountInput,
            NameInput,
            UpdatePricePlan,
            AllocatedCreditInput
        },
        computed: {
            isCreateForm() {
                return this.$router.currentRoute.name === 'NewPricePlan'
            }
        },
        methods: {
            goBack() {
                this.$store.dispatch('changeNewPricePlanFieldToDefault')
                this.$router.push({ path: '/plans' })
            }
        },
        created() {
            if(this.$router.currentRoute.name === 'NewPricePlan'){
                this.$store.dispatch('changeNewPricePlanFieldToDefault')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/NewPricePlan.vue